import { Youtube } from "lucide-react";
import { CHANNEL_URL } from "@/constants/roles";
import { MeltoLogo } from "@/components/MeltoLogo";

export const Footer = () => {
  return (
    <footer className="border-t border-slate-200/60 py-12">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-5 px-4 sm:flex-row sm:px-6">
        <div className="flex items-center gap-2">
          <MeltoLogo size={28} testid="footer-logo-mark" />
          <span className="font-display text-sm font-semibold text-slate-900">Melto Studios</span>
        </div>
        <p data-testid="footer-note" className="text-xs text-slate-400">
          Crew recruitment for the ItsMelto YouTube channel. Remote & paid per video.
        </p>
        <a
          data-testid="footer-youtube-link"
          href={CHANNEL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1.5 text-sm font-medium text-slate-500 transition-colors hover:text-cyan-600"
        >
          <Youtube className="h-4 w-4" /> @ItsMelto
        </a>
      </div>
    </footer>
  );
};
